var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-basic-min-width default-layout app-flex-column"},[_c('MHeader'),_c('div',{staticClass:"main app-flex-column"},[_c('router-view')],1),_c('MFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }